import styled from '@emotion/styled';
import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

const SpinnerWrapper = styled.div`
    margin: 25vh auto 0;
    text-align: center;
    .label {
        font-size: 50px;
        display: inline-block;
    }
    .spinner {
        width: 80px;
        text-align: center;
        display: inline-block;
        > div {
            width: 18px;
            height: 18px;
            background-color: #333;
            border-radius: 100%;
            display: inline-block;
            animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        }
        .bounce1 {
            animation-delay: -0.32s;
        }
        .bounce2 {
            animation-delay: -0.16s;
        }
        @keyframes sk-bouncedelay {
            0%,
            80%,
            100% {
                transform: scale(0);
            }
            40% {
                transform: scale(1);
            }
        }
    }
`;

export const BigSpinner = (props: PropsWithChildren) => {
    const { t } = useTranslation();
    return (
        <SpinnerWrapper {...props}>
            <div className="spinner">
                <div className="bounce1" />
                <div className="bounce2" />
                <div className="bounce3" />
            </div>
            <div className="label">{t('label.loading', 'Loading')}</div>
        </SpinnerWrapper>
    );
};
